'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _effects = require('redux-saga/effects');

var _reactSpectraEditor = require('@complat/react-spectra-editor');

var _action_type = require('../constants/action_type');

var _fetcher_predict = require('../fetchers/fetcher_predict');

var _fetcher_predict2 = _interopRequireDefault(_fetcher_predict);

var _helper = require('../utils/helper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(predictByServer),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(predictToWriteByServer);

function predictByServer(action) {
  var payload, rsp;
  return regeneratorRuntime.wrap(function predictByServer$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = action.payload;
          _context.next = 3;
          return (0, _effects.call)(_fetcher_predict2.default.predict, payload);

        case 3:
          rsp = _context.sent;

          if (!(rsp && rsp.outline.code)) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return (0, _effects.put)({
            type: _action_type.PREDICT.PREDICT_DONE,
            payload: rsp
          });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.next = 11;
          return (0, _effects.put)({
            type: _action_type.PREDICT.PREDICT_FAIL,
            payload: rsp
          });

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked);
}

function predictToWriteByServer(action) {
  var payload, peaks, layout, shift, isAscend, decimal, rsp, predictions, body, wrapper, desc;
  return regeneratorRuntime.wrap(function predictToWriteByServer$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = action.payload;
          peaks = payload.peaks, layout = payload.layout, shift = payload.shift, isAscend = payload.isAscend, decimal = payload.decimal;
          _context2.next = 4;
          return (0, _effects.call)(_fetcher_predict2.default.predict, payload);

        case 4:
          rsp = _context2.sent;

          if (!(rsp && rsp.outline.code)) {
            _context2.next = 16;
            break;
          }

          _context2.next = 8;
          return (0, _effects.put)({
            type: _action_type.PREDICT.PREDICT_DONE,
            payload: rsp
          });

        case 8:
          predictions = rsp.output.result[0].shifts;
          body = _reactSpectraEditor.FN.formatPeaksByPrediction(peaks, layout, isAscend, decimal, predictions);
          wrapper = _reactSpectraEditor.FN.peaksWrapper(layout, shift);
          desc = (0, _helper.RmDollarSign)(wrapper.head) + body + wrapper.tail;
          _context2.next = 14;
          return (0, _effects.put)({
            type: _action_type.DESC.UPDATE,
            payload: desc
          });

        case 14:
          _context2.next = 18;
          break;

        case 16:
          _context2.next = 18;
          return (0, _effects.put)({
            type: _action_type.PREDICT.PREDICT_FAIL,
            payload: rsp
          });

        case 18:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2);
}

var predictSagas = [(0, _effects.takeEvery)(_action_type.PREDICT.PREDICT_INIT, predictByServer), (0, _effects.takeEvery)(_action_type.PREDICT.PREDICT_TO_WRITE_INIT, predictToWriteByServer)];

exports.default = predictSagas;